import React from 'react';
import {UserProps} from 'modules/users/types';
import usersKeys from 'modules/users/util/users-keys';
import {GrForwardTen} from 'react-icons/gr';
import List from 'shared/layout/list';
import {AnalyticsCardListProps} from 'shared/layout/list/state';
import ApiSwitch from 'shared/migration-components/api-switch';
import useProjection from 'shared/migration-hooks/use-projection';
import dateFnsService from 'shared/services/date-fns-service';
import ApiDynamicButton from 'shared/migration-components/api-dynamic-button';
import {IoTrash} from 'react-icons/io5';

const Users: React.FC = () => {
  const projection = useProjection<UserProps>('users', [
    'number',
    'name',
    'email',
    'phone',
    'cpf',
    'active',
    'createdAt',
    'id',
    'phoneConfirmed',
  ]);

  const analyticsCards: AnalyticsCardListProps[] = [
    {
      label: 'Total de registros',
      field: 'count',
      icon: <GrForwardTen />,
    },
  ];

  return (
    <List<UserProps>
      {...{
        analyticsCards,
        titleBar: {
          title: 'Usuários',
          actionButton: {title: 'NOVO USUÁRIO', to: 'create'},
        },
        table: {
          url: '/users',
          projection: {
            ...projection,
            options: [
              {value: 'number', filter: {valueAsNumber: true}},
              'name',
              'email',
              {
                value: 'active',
                column: {
                  value: (row) => (
                    <ApiSwitch
                      field="active"
                      queryKey={usersKeys.list()}
                      url={`/users/${row.id}/active`}
                      isChecked={row.active}
                    />
                  ),
                  stopPropagation: true,
                },
                filter: {
                  type: 'select',
                  values: [
                    {
                      label: 'Sim',
                      value: true,
                    },
                    {
                      label: 'Não',
                      value: false,
                    },
                  ],
                },
              },
              {
                value: 'phoneConfirmed',
                column: {
                  value: (row) => (
                    <ApiSwitch
                      disabled={row.phoneConfirmed}
                      field="phoneConfirmed"
                      queryKey={usersKeys.list()}
                      url={`/users/${row.id}/confirm-phone`}
                      isChecked={!!row.phoneConfirmed}
                    />
                  ),
                  stopPropagation: true,
                },
                filter: {
                  type: 'select',
                  values: [
                    {
                      label: 'Sim',
                      value: true,
                    },
                    {
                      label: 'Não',
                      value: false,
                    },
                  ],
                },
              },
              'phone',
              'cpf',
              {
                value: 'createdAt',
                column: (row) =>
                  row.createdAt && dateFnsService.dateTimeFormat(row.createdAt),
                filter: {type: 'date'},
              },
              {
                label: 'Ações',
                value: 'id',
                column: (row) => (
                  <ApiDynamicButton
                    keys={{deleteInfiniteList: usersKeys.list()}}
                    button={{icon: <IoTrash />, tooltip: 'Remover usuário'}}
                    request={{
                      errorTitle: 'Erro ao remover usuário',
                      method: 'DELETE',
                      url: `/users/${row.id}`,
                    }}
                    confirmButtonText="usuário"
                  />
                ),
              },
            ],
          },
          translatedPropsKey: 'UserProps',
        },
        fixedColumns: ['phoneConfirmed'],
        queryKey: usersKeys.list(),
      }}
    />
  );
};

export default Users;
